const jobsReducer = (
  state = {
    loading: false,
    data: null,
  },
  action
) => {
  switch (action.type) {
    case "SET_JOBS_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };

    case "SET_JOBS_DATA":
      return {
        ...state,
        data: action.payload.data,
      };

    case "UPDATE_JOBS_DATA":
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };

    case "RESET":
      return {
        loading: false,
        data: null,
      };

    default:
      return state;
  }
};
export default jobsReducer;
